// extracted by mini-css-extract-plugin
module.exports = {"icon":"Accordion_icon__Hx4MR","extraInfo":"Accordion_extraInfo__FhM2S","button":"Accordion_button__t5i3t"};